import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import {BiReportHdrModel, ReportContainerModel} from '../../../../../../models';
import {ApiVisa, BasicApiResponseModel} from '../../shared';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BiReportHdrService extends BaseApiTemplateService<BiReportHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    'bi-reports/hdrs/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/hdrs/backoffice-ep';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/hdrs/backoffice-ep';
    this.httpClient = theHttp;
  }

  generateReport(body: BiReportHdrModel, visa: ApiVisa): Observable<BasicApiResponseModel<ReportContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/hdrs/execute-report/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/hdrs/execute-report/backoffice-ep';
    }

    return this.httpClient.post<BasicApiResponseModel<ReportContainerModel>>(url, body, this.getHttpHeader(visa));
  }

  updateReport(body: BiReportHdrModel, visa: ApiVisa): Observable<BasicApiResponseModel<ReportContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/hdrs/execute-report/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/hdrs/execute-report/backoffice-ep';
    }

    return this.httpClient.put<BasicApiResponseModel<ReportContainerModel>>(url, body, this.getHttpHeader(visa));
  }
}
